import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Perfil} from './perfil.model';
import {BaseService} from '../services/base-service.service';
import {ConsultaPaginada, ConsultaPaginadaResultado} from 'maestro-ng';
import {firstValueFrom} from 'rxjs';

@Injectable()
export class PerfilService extends BaseService<Perfil, number> {

  constructor(http: HttpClient) {
    super('perfil', http);
  }

  public newEntity(): Perfil {
    return {};
  }

  public getId(entity: Perfil): number {
    return entity.id;
  }

  public recuperarPorId(id: number): Promise<Perfil> {
    return firstValueFrom(this.http.get<Perfil>(this.path(`${id}`)));
  }

  public recuperarTodos(): Promise<Perfil[]> {
    return firstValueFrom(this.http.get<Perfil[]>(this.path('')));
  }

  public recuperarPaginado(consulta: ConsultaPaginada): Promise<ConsultaPaginadaResultado<Perfil>> {
    return this.service.recuperarPaginado(consulta);
  }

  public excluir(perfil: Perfil): Promise<void> {
    return firstValueFrom(this.http.delete<void>(this.path(`${perfil.id}`)));
  }

  public salvar(perfil: Perfil, isInsercao: boolean): Promise<Perfil> {
    if (isInsercao) {
      return firstValueFrom(this.http.post<Perfil>(this.path(''), perfil, {headers: this.createJsonHttpHeaders()}));
    }
    else {
      return firstValueFrom(this.http.put<Perfil>(this.path(''), perfil, { headers: this.createJsonHttpHeaders() }));
    }
  }

  public recuperarPerfilPorUsuario(usuarioId: number): Promise<Perfil[]> {
    return firstValueFrom(this.http.get<Perfil[]>(this.path(`/recuperarPerfilPorUsuario/${usuarioId}`)));
  }

  public recupararPerfilNaoPertecenteAoRecursoSeguranca(recursoSegurancaId: number): Promise<Perfil[]> {
    return firstValueFrom(this.http.get<Perfil[]>(this.path(`recupararPerfilNaoPertecenteAoRecursoSeguranca/${recursoSegurancaId}`)));
  }

  public recuperarDisponiveisParaRecursoSegurancaId(recursoSegurancaId: number): Promise<Perfil[]> {
    return firstValueFrom(this.http.get<Perfil[]>(this.path(`recuperarDisponiveisParaRecursoSegurancaId/${recursoSegurancaId}`)));
  }

  public recuperarItens(): Promise<Perfil[]> {
    return this.service.recuperarItens();
  }

  public recuperarItensPorTipoUsuario(tipoUsuario: string): Promise<Perfil[]> {
    return firstValueFrom(this.http.get<Perfil[]>(this.path(`recuperarItensPorTipoUsuario/${tipoUsuario}`)));
  }

}
